import {
  colorDisabledDisabled,
  colorErrorError,
  colorPrimaryOnPrimary,
  colorPrimaryOnPrimaryContainer,
  colorPrimaryPrimary,
  textPrimaryOnColorPrimary,
  textPrimaryPrimary,
  textSecondarySecondary,
} from "@/app/(styles)/variables.js";
import { Manrope } from "next/font/google";
import { createTheme } from "@mui/material";

const manrope = Manrope({
  weight: ["300", "400", "500", "600", "700"],
  style: ["normal"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-manrope",
});
const theme = createTheme({
  typography: {
    fontFamily: manrope.style.fontFamily,
  },
  palette: {
    primary: {
      main: colorPrimaryPrimary,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: ${manrope.style.fontFamily};
          font-weight: 300 700;
        }
      `,
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: colorPrimaryOnPrimary,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          borderColor: colorDisabledDisabled,
        },
        deleteIcon: {
          color: textPrimaryPrimary,
          width: "20px",
          height: "20px",
          ":hover": {
            color: textPrimaryPrimary,
          },
        },
        label: {
          color: textSecondarySecondary,
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0px 7px 10px 5px #00000026",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: colorPrimaryPrimary,
          ":checked": {
            color: colorPrimaryPrimary,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          ":checked": {
            color: colorPrimaryPrimary,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          color: textPrimaryOnColorPrimary,
          fontSize: "14px",
          fontWeight: "400",
        },
        filledSuccess: {
          backgroundColor: colorPrimaryOnPrimaryContainer,
        },
        filledError: {
          backgroundColor: colorErrorError,
        },
      },
    },
  },
});
export default theme;
